import Vue from 'vue';
import DesignSystem from '@infusionsoft/design-system';
import components from '@infusionsoft/design-system/src/components';
import { initializeApp, getApps, getApp } from 'firebase/app';
import i18n from '@/utils/i18n.util';
import slack from '@/components/util/slack/slack.utils';
import amplitude from '@/components/util/analytics/amplitude';
import ENVIRONMENTS from '@/firebase.env.constants';
import vClickOutside from 'v-click-outside';
import PortalVue from 'portal-vue';
import VueClipboard from 'vue-clipboard2';
import VueKonva from 'vue-konva';

window.mxLoadResources = false;
window.mxLoadStylesheets = false;

const ContactRecordPage = require('./components/contact/ContactRecordPage.vue').default;
const SwapContact = require('./components/contact/SwapContact.vue').default;
const AnalyticsReportPage = require('./components/analytics/AnalyticsReportPage.vue').default;
const CampaignSmsBuilderModal = require('./components/automatedSms/CampaignSmsBuilderModal.vue').default;
const EcommSetupPage = require('./components/ecomm/EcommSetupPage.vue').default;
const AllSavedReports = require('./components/reports/AllSavedReports.vue').default;
const ReportsPage = require('./components/reports/ReportsPage.vue').default;
const AllSettings = require('./components/settings/AllSettings.vue').default;
const BounceReport = require('./components/emailreports/BounceReport.vue').default;
const SetFieldValue = require('./components/funnel/legacy/setFieldValue/SetFieldValue.vue').default;
const ProductPurchasedModal = require('./components/funnel/legacy/ProductPurchasedModal.vue').default;
const MoveOpportunityFlow = require('./components/funnel/legacy/flow/MoveOpportunityFlow.vue').default;
const ConvrrtLandingPage = require('./components/funnel/legacy/landingPage/ConvrrtLandingPage.vue').default;
const ConvrrtLandingPageThirdParty = require('./components/funnel/legacy/landingPage/ConvrrtLandingPageThirdParty.vue').default;
const UnlayerLandingPage = require('./components/funnel/legacy/UnlayerLandingPage.vue').default;
const CampaignUnlayerBuilderModal = require('./components/unlayer/CampaignUnlayerBuilderModal.vue').default;
const BardToUnlayerMigrationPreview = require('./components/unlayer/BardToUnlayerMigrationPreview.vue').default;
const LeadGenerationPage = require('./components/marketing/LeadGenerationPage.vue').default;
const MarketingSitePage = require('./components/marketing/MarketingSitePage.vue').default;
const MarketingSiteEditor = require('./components/marketing/MarketingSiteEditor.vue').default;
const MarketingSiteGallery = require('./components/marketing/MarketingSiteGallery.vue').default;
const CustomDomainMgmt = require('./components/customDomain/CustomDomainMgmt.vue').default;
const CheckForDupsPage = require('./components/dataCleanUp/CheckForDupsPage.vue').default;
const PageNotFound = require('./components/pageNotFound/PageNotFound.vue').default;
const ContactsUsageAlert = require('./components/contact/ContactsUsageAlert.vue').default;
const AnalyticsDashboardPage = require('./components/analytics/AnalyticsDashboardPage.vue').default;
const CampaignBuilder = require('./components/funnel/konva-campaign-editor/CampaignBuilder.vue').default;
const RecipientRiskEmailInput = require('./components/contact/email/RecipientRiskEmailInput.vue').default;

// Settings
const DomainSettingsPage = require('./components/settings/email/DomainSettingsPage.vue').default;

// Broadcasts
const BroadcastsPage = require('./components/broadcast/BroadcastsPage.vue').default;

// Reports
const EmailHealth = require('./components/emailreports/EmailHealth.vue').default;
const ComplaintDetailsPage = require('./components/emailreports/ComplaintDetailsPage.vue').default;
const BounceDetailsPage = require('./components/emailreports/BounceDetailsPage.vue').default;
const EngagementDetailsPage = require('./components/emailreports/EngagementDetailsPage.vue').default;


// MessageHistory
const SmsMessageHistory = require('./components/automatedSms/SmsMessageHistory.vue').default;

// Account Management
const AccountContactUsage = require('./components/accountManagement/AccountContactUsage.vue').default;
const AccountUserUsage = require('./components/accountManagement/AccountUserUsage.vue').default;
const AccountEmailVolumeMonthlyUsage = require('./components/accountManagement/AccountEmailVolumeMonthlyUsage.vue').default;
const QuickAddModal = require('./components/accountManagement/QuickAddModal.vue').default;
const ScheduleChangesForQuickAdd = require('./components/accountManagement/ScheduledChangesForQuickAdd.vue').default;
const ProServicesPage = require('./components/accountManagement/ProServicesPage.vue').default;

// AccountTextUsage
const SmsAccountUsage = require('./components/automatedSms/SmsAccountUsage.vue').default;

// Dashboard
const ChangeLayout = require('./components/dashboard/ChangeLayout.vue').default;

// feedback modal
const ShareFeedbackModal = require('./components/shared/ShareFeedbackModal.vue').default;

const StripePaymentMethodForm = require('./components/contact/StripePaymentMethodForm.vue').default;
const OrderFormStripePaymentMethodForm = require('./components/orderform/OrderFormStripePaymentMethodForm.vue').default;
const ShoppingCartStripePaymentMethodForm = require('./components/shoppingcart/ShoppingCartStripePaymentMethodForm.vue').default;
const InvoiceStripePaymentMethodForm = require('./components/invoice/InvoiceStripePaymentMethodForm.vue').default;
const QuoteStripePaymentMethodForm = require('./components/quote/QuoteStripePaymentMethodForm.vue').default;

// CampaignBuilder
Vue.use(VueKonva);

let firebaseConfig = {};

if (window.environment === 'Production') {
    firebaseConfig = ENVIRONMENTS.PRODUCTION;
} else if (window.environment === 'Staging') {
    firebaseConfig = ENVIRONMENTS.STAGING;
    Vue.config.devtools = true;
    Vue.config.debug = true;
} else if (window.environment) {
    firebaseConfig = ENVIRONMENTS.DEVELOPMENT;
    Vue.config.devtools = true;
    Vue.config.debug = true;
}

Vue.component('contact-record-page', ContactRecordPage);
Vue.component('swap-contact', SwapContact);
Vue.component('analytics-report-page', AnalyticsReportPage);
Vue.component('campaign-sms-builder-modal', CampaignSmsBuilderModal);
Vue.component('ecomm-setup-page', EcommSetupPage);
Vue.component('all-saved-reports', AllSavedReports);
Vue.component('reports-page', ReportsPage);
Vue.component('bounce-report', BounceReport);
Vue.component('set-field-value', SetFieldValue);
Vue.component('product-purchased-modal', ProductPurchasedModal);
Vue.component('move-opportunity-flow', MoveOpportunityFlow);
Vue.component('convrrt-landing-page', ConvrrtLandingPage);
Vue.component('convrrt-landing-page-third-party', ConvrrtLandingPageThirdParty);
Vue.component('unlayer-landing-page', UnlayerLandingPage);
Vue.component('campaign-unlayer-builder-modal', CampaignUnlayerBuilderModal);
Vue.component('bard-to-unlayer-migration-preview', BardToUnlayerMigrationPreview);
Vue.component('lead-generation-page', LeadGenerationPage);
Vue.component('marketing-site-page', MarketingSitePage);
Vue.component('marketing-site-editor', MarketingSiteEditor);
Vue.component('marketing-site-gallery', MarketingSiteGallery);
Vue.component('custom-domain-mgmt', CustomDomainMgmt);
Vue.component('check-for-dups-page', CheckForDupsPage);
Vue.component('page-not-found', PageNotFound);
Vue.component('contacts-usage-alert', ContactsUsageAlert);
Vue.component('analytics-dashboard-page', AnalyticsDashboardPage);
Vue.component('campaign-builder', CampaignBuilder);
Vue.component('recipient-risk-email-input', RecipientRiskEmailInput);

// Settings
Vue.component('domain-settings-page', DomainSettingsPage);

// Broadcasts
Vue.component('broadcasts-page', BroadcastsPage);

// Reports
Vue.component('email-health', EmailHealth);
Vue.component('complaint-details-page', ComplaintDetailsPage);
Vue.component('bounce-details-page', BounceDetailsPage);
Vue.component('engagement-details-page', EngagementDetailsPage);

// Settings
Vue.component('all-settings', AllSettings);


// MessageHistory
Vue.component('sms-message-history', SmsMessageHistory);

// Account Management
Vue.component('account-contact-usage', AccountContactUsage);
Vue.component('account-user-usage', AccountUserUsage);
Vue.component('account-email-volume-monthly-usage', AccountEmailVolumeMonthlyUsage);
Vue.component('quick-add-modal', QuickAddModal);
Vue.component('schedule-changes-for-quick-add', ScheduleChangesForQuickAdd);
Vue.component('pro-services-page', ProServicesPage);

// AccountTextUsage
Vue.component('sms-account-usage', SmsAccountUsage);

// Dashboard
Vue.component('change-layout', ChangeLayout);

// Feedback
Vue.component('share-feedback-modal', ShareFeedbackModal);

// Stripe Payment Elements
Vue.component('stripe-payment-method-form', StripePaymentMethodForm);
Vue.component('order-form-stripe-payment-method-form', OrderFormStripePaymentMethodForm);
Vue.component('shopping-cart-stripe-payment-method-form', ShoppingCartStripePaymentMethodForm);
Vue.component('invoice-stripe-payment-method-form', InvoiceStripePaymentMethodForm);
Vue.component('quote-stripe-payment-method-form', QuoteStripePaymentMethodForm);

Vue.use(DesignSystem, { components });
Vue.use(vClickOutside);
Vue.use(VueClipboard);
Vue.use(PortalVue);
Vue.prototype.$slack = slack.sendFeedback;
Vue.prototype.$firebase = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
Vue.prototype.$t = i18n.$t;
Vue.prototype.$tc = i18n.$tc;
Vue.prototype.$te = i18n.$te;
Vue.config.productionTip = false;

amplitude.keap.init();
amplitude.keap.setup({ appName: window.appName });
amplitude.infusionsoft.init();
amplitude.infusionsoft.setUserId(window.appName);

window.Vue = Vue;
